export default "__VITE_ASSET__c55bddab__"